import { useEffect, useRef, useState } from "react";
import { UserSuccessorAccount } from "hooks/investments/GetUserSuccessorAccountsAdminHook";
import { SVG_ENUM } from "enums";
import SVG from "shared/SVG";

interface SuccessorOwnerPickerProps {
  accounts: UserSuccessorAccount[];
  selectedOwnerUuid: string | null;
  onSelect: (ownerUuid: string) => void;
}

const SuccessorOwnerPicker = ({
  accounts,
  selectedOwnerUuid,
  onSelect,
}: SuccessorOwnerPickerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const pickerRef = useRef<HTMLDivElement>(null);

  const selectedAccount = accounts.find(
    (account) => account.ownerUuid === selectedOwnerUuid,
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  if (accounts.length === 0) {
    return null;
  }

  return (
    <div className="user-assets-list__owner-picker" ref={pickerRef}>
      <div
        className="user-assets-list__owner-picker-trigger"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span>{selectedAccount?.ownerName ?? "-"}</span>
        <div
          className={`user-assets-list__owner-picker-arrow ${
            isOpen ? "user-assets-list__owner-picker-arrow--open" : ""
          }`}
        >
          <SVG type={SVG_ENUM.CHEVRON_DOWN} />
        </div>
      </div>
      {isOpen && (
        <ul className="user-assets-list__owner-picker-menu">
          {accounts.map((account) => (
            <li
              key={account.ownerUuid}
              className={`user-assets-list__owner-picker-item ${
                account.ownerUuid === selectedOwnerUuid
                  ? "user-assets-list__owner-picker-item--active"
                  : ""
              }`}
              onClick={() => {
                onSelect(account.ownerUuid);
                setIsOpen(false);
              }}
            >
              {account.ownerName}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SuccessorOwnerPicker;
